import getDefaultStyle from '../css/defaultStyle';

import merge from 'lodash-es/merge';

const cssStyle = (control) => {
  const res = {
    normal: merge({}, getDefaultStyle(), {
      position: 'absolute',
      transitionProperty: 'all',
      transitionDuration: '${schemeAnimationDuration}',
      transitionTimingFunction: 'ease',
      transitionDelay: '0s',
      boxSizing: 'border-box',
      height: '50px',
      left: '0px',
      top: '0px',
      width: '50px',
      display: 'inline-block',
      margin: '0px',
      zIndex: 0,
      // opacity:control.isVisible?1:0,
    }),
    hover: {},
    body:{
      normal:{
        position:'absolute',
        top:0,right:0,bottom:0,left:0,
        backgroundColor: 'rgba(0,0,0,0.4)',
        borderColor: 'rgba(255,255,255,0.2)',
        borderWidth: '1px',
        borderStyle: 'solid',
      },
      hover: {

      },
    }
  };
  if (control.isLayoutMode || control.isDesignMode) {
    res.body.hover.backgroundColor = 'rgba(0,0,0,0.6)';    
    res.body.hover.borderColor = 'rgba(255,255,255,0.6)';    
  } 

  return res;
};

function createElement(control) {
  const element = document.createElement('div');
  element.classList.add('controls');
  element.classList.add('layout-container');
  //if (control.isLayoutMode) {
    element.innerHTML = '<div class="body">';
  //}

  return element;
}

export default {
  cssStyle,
  createElement,
};
